import { Td } from '@chakra-ui/react';
import * as T from '../../../components/Table';
import { PermissaoLiberacao } from './PermissaoLiberacao';

export function UserItem({ user }) {
  return (
    <T.Tr key={user.codigo_usuario}>
      <Td textAlign="center" borderRight="1px solid #cecece!important">
        {user.nome_usuario}
      </Td>
      <Td textAlign="center" borderRight="1px solid #cecece!important">
        {user.codigo_usuario}
      </Td>
      <Td textAlign="center" borderRight="1px solid #cecece!important">
        {user.ativo_fila ? 'Sim' : 'Não'}
      </Td>
      <Td textAlign="center" borderRight="1px solid #cecece!important">
        {user.email_usuario}
      </Td>
      <Td textAlign="center" borderRight="1px solid #cecece!important">
        {user.crm_login}
      </Td>
      <Td
        textAlign="center"
        borderRight="1px solid #cecece!important"
        color={user.liberador ? 'green.500' : 'red.500'}>
        {user.liberador ? 'Sim' : 'Não'}
      </Td>
      <Td
        textAlign="center"
        borderRight="1px solid #cecece!important"
        color={user.usuario_ativo ? 'green.500' : 'red.500'}>
        {user.usuario_ativo ? 'Sim' : 'Não'}
      </Td>

      <Td textAlign="center">
        <PermissaoLiberacao user={user} />
      </Td>
    </T.Tr>
  );
}
